import {URL_API_GENERATE_DYNAMIC_TABLES} from '../apiHitFile';

export function GenerateTable(obj){
    return (dispatch, getState) => {
      let headers = new Headers()
      headers.append('Content-Type','application/json');
      headers.append('Accept','application/json');
      fetch(URL_API_GENERATE_DYNAMIC_TABLES, {
        method: 'POST',
        headers : headers,
        body:JSON.stringify(obj)
      }).then((res) => res.json())
        .then(json =>  dispatch(dynamicTableError(json)))
        .catch(error => dispatch(dynamicTableError(error)))
    }
}
export function dynamicTableError(data){
    return {
      type: "DYNAMIC_TABLE_ERROR",
      showerror:true, 
      errmessage:data.message
    }
}
export function closeModalPopUp(){
    return{
      type:'DYNAMIC_TABLE_CLOSE',
      showerror:false
    }
}